import { Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { useNavigate, useParams } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import type { TextContent } from "../../types"
import { initialValuesText, validationSchemaText } from "./TextCommon"
import { useText, useUpdateText } from "../../hooks/texts"
import TextForm from "./TextForm"

export default function TextUpdate() {
  const updateText = useUpdateText()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: text } = useText(Number(id))

  const initialValues = useMemo(() => initialValuesText(text), [text])
  const validationSchema = useMemo(() => validationSchemaText(), [])

  useBreadcrumbs([{ label: "Testi", href: "/text-contents/text-contents" }, { label: "Dettaglio Testo" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{text?.key}</H1>
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              return updateText.mutateAsync(values as TextContent).then(() => {
                navigate(`/text-contents/text-contents`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <TextForm />
                </Container>
                <BottomFormFixed url="/text-contents/text-contents" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
